var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1783 19.449C20.7807 18.7261 18.4754 17.7778 16 17.7778C13.5246 17.7778 11.2193 18.7261 9.82171 19.449C8.91938 19.9158 8.37596 20.8312 8.25627 21.84L8 24H24L23.7437 21.84C23.624 20.8312 23.0806 19.9158 22.1783 19.449Z",
    fill: "#383FEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C18.2091 16 20 14.2091 20 12C20 9.79086 18.2091 8 16 8C13.7909 8 12 9.79086 12 12C12 14.2091 13.7909 16 16 16Z",
    fill: "#383FEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.4068a7b99e1b0d6babb827bb7a893e87.svg";
export { ForwardRef as ReactComponent };